class CSFeaturedProducts extends HTMLElement {
    constructor() {
        super();

        this.tabs = this.querySelectorAll('.featproducts-tabs button');
        this.groups = this.querySelectorAll('.featproducts-products');

        this.tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                let index = tab.dataset.index;

                this.tabs.forEach(tab => {
                    tab.classList.remove('active');
                });
                tab.classList.add('active');

                this.groups.forEach(group => {
                    group.classList.remove('active');
                });
                this.groups[index].classList.add('active');
                
            });
        });

        this.groups.forEach(group => {
            new Flickity(group, { 
                'prevNextButtons': false,
                'cellAlign': 'center',
                'pageDots': true, 
                'wrapAround': true,
                'watchCSS': true 
            });
        });
        
    }
}
  
customElements.define('cs-featured-products', CSFeaturedProducts);
  